import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';
import paginationComponent from '../../../components/pagination/pagination.component';
import StorePopupDialog from './store-popup.dialog';
import SchedulePopupDialog from './schedule-popup.dialog';

export default function SummaryTabView() {
    ViewBase.call(this);

    let summaryData = [];
    let totalCount = 0;
    let pageIndex = 1;
    let pageSize = 10;
    let filter = {};

    // Dialog state
    let storeDialogOpen = false;
    let scheduleDialogOpen = false;
    let selectedGroup = {};

    let loadSummary = () => {
        this.showLoading();
        aiJpoModel.getSummary({
            countryCode: filter.countryCode,
            bu: filter.bu,
            month: filter.month,
            page: pageIndex,
            pageSize: pageSize
        })
            .then((result) => {
                summaryData = result.items || [];
                totalCount = result.total || 0;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    };

    let onPageChanged = (p) => {
        pageIndex = p;
        loadSummary();
    };

    let onPageSizeChanged = (p, ps) => {
        pageIndex = p;
        pageSize = ps;
        loadSummary();
    };

    let openStorePopup = (groupID, groupName, storeCount) => {
        selectedGroup = { groupID, groupName, storeCount, month: filter.month };
        storeDialogOpen = true;
    };

    let openSchedulePopup = (groupID, groupName) => {
        selectedGroup = { groupID, groupName, month: filter.month };
        scheduleDialogOpen = true;
    };

    return {
        oninit: ({ attrs }) => {
            filter = attrs.filter;
            loadSummary();
        },
        onupdate: ({ attrs }) => {
            if (attrs.searchVersion !== filter._searchVersion) {
                filter = attrs.filter;
                filter._searchVersion = attrs.searchVersion;
                pageIndex = 1;
                loadSummary();
            }
        },
        view: () => {
            let lastZone = null;
            let rows = [];

            summaryData.forEach((row) => {
                if (row.zoneName !== lastZone) {
                    if (rows.length > 0) rows.push(null);
                    rows.push(
                        m('tr.ai-jpo-zone-row',
                            m('td', { colspan: '10' }, languageModel.getText('', 'Zone') + ': ' + (row.zoneName || ''))
                        )
                    );
                    lastZone = row.zoneName;
                }
                rows.push(
                    m('tr', [
                        m('td', ''),
                        m('td', row.groupName || ''),
                        m('td.text-center.ai-jpo-link-cell', {
                            onclick: () => openStorePopup(row.groupID, row.groupName, row.storeCount)
                        }, row.storeCount ?? 0),
                        m('td.text-center.ai-jpo-link-cell', {
                            onclick: () => openSchedulePopup(row.groupID, row.groupName)
                        }, row.visitCount ?? 0),
                        m('td.text-end', (row.totalHours != null ? Number(row.totalHours).toFixed(1) : '0') + 'h'),
                        m('td.text-center', row.gradeA ?? 0),
                        m('td.text-center', row.gradeB ?? 0),
                        m('td.text-center', row.gradeC ?? 0),
                        m('td.text-center', row.gradeD ?? 0),
                        m('td.text-center', row.gradeE ?? 0),
                    ])
                );
            });

            return [
                m('.card',
                    m('.card-body',
                        m('.table-responsive',
                            m('table.table.table-bordered',
                                m('thead.thead-bggrey',
                                    m('tr.align-middle', [
                                        m('th', { scope: 'col', style: 'width: 40px;' }, ''),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Group')),
                                        m('th', { scope: 'col', style: 'width: 90px;' }, languageModel.getText('', 'Stores')),
                                        m('th', { scope: 'col', style: 'width: 90px;' }, languageModel.getText('', 'Visits')),
                                        m('th', { scope: 'col', style: 'width: 90px;' }, languageModel.getText('', 'Total Hours')),
                                        m('th', { scope: 'col', style: 'width: 70px;' }, 'A'),
                                        m('th', { scope: 'col', style: 'width: 70px;' }, 'B'),
                                        m('th', { scope: 'col', style: 'width: 70px;' }, 'C'),
                                        m('th', { scope: 'col', style: 'width: 70px;' }, 'D'),
                                        m('th', { scope: 'col', style: 'width: 70px;' }, 'E'),
                                    ])
                                ),
                                m('tbody',
                                    summaryData.length === 0 &&
                                        m('tr.align-middle',
                                            m('td', { colspan: '10' }, languageModel.getText('', 'No records found.'))
                                        ),
                                    rows
                                )
                            )
                        ),
                        !this._isLoading &&
                            m('.px-3.pt-2',
                                m(paginationComponent, {
                                    currentPage: pageIndex,
                                    pageSize: pageSize,
                                    totalItems: totalCount,
                                    onPageChanged: onPageChanged,
                                    onPageSizeChanged: onPageSizeChanged
                                })
                            )
                    )
                ),

                // Dialogs
                m(StorePopupDialog, {
                    isOpen: storeDialogOpen,
                    group: selectedGroup,
                    onClose: () => { storeDialogOpen = false; }
                }),
                m(SchedulePopupDialog, {
                    isOpen: scheduleDialogOpen,
                    group: selectedGroup,
                    onClose: () => { scheduleDialogOpen = false; }
                })
            ];
        }
    };
}
